module.exports = __webpack_public_path__ + "static/media/Andy.92b4ceaf.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Andy.pdf
// module id = 16
// module chunks = 0